import Basic from './basic';
import Icon from './icon';
import Center from './center';
import End from './end';
const Pagination = { Basic, Icon, Center, End };
export default Pagination;
